import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ButtonDefault from "../../components/ButtonDefault";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPencil } from "@fortawesome/free-solid-svg-icons";
import "./styles.css";
import ReportsFolderStructure from "../../components/ReportsFolderStructure";
import ReportEditor from "../ReportEditor";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import generatePDF from "react-to-pdf";
import { useDispatch, useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import RenderDocument from "../../components/RenderDocument";
import ReactPDF, { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { getEvaluationReport, getEvaluationReportFolders, getEvaluationReportList } from "../../api/reports";
import { setReportData } from "../../redux/reducers/evaluation";
import ReportSkeleton from "../../components/ReportSkeleton";
import { genUID } from "../../common/StaticExports";
// import { getClubLogo } from "../../api/common";

const ReportsWrapper = (props: any) => {
  const [t] = useTranslation();
  const reportData = useSelector((state: any) => state.evaluation.reportData);
  const currentClub = useSelector((state:any) => state.clubDetails);
  const selected = useSelector((state: any) => state.evaluation.selectedReportEntity);
  const isFile = useSelector((state: any) => state.evaluation.isSelectedReport);
  const staffList = useSelector((state:any) => state.evaluation.staffList);
  const htmlStringES = useSelector((state:any) => state.evaluation.executiveSummaryRichText);
  const dispatch = useDispatch();
  const [isFetchingReport, setIsFetchingReport] = useState(false);
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);

  // const fetchLogo = async () => {
  //   try {
  //     const response = await getClubLogo(`https://jamp.football${currentClub?.logo}`);
      
  //     const blob = await response.blob();
      
  //     // Convert blob to Base64
  //     const reader:any = new FileReader();
  //     reader.onloadend = () => {
  //       return reader.result;
  //     };
  //     reader.readAsDataURL(blob);
  //   } catch (error) {
  //     console.error('Error fetching logo:', error);
  //   }
  // };

  const downloadPDF = async () => {
    setIsDownloadingReport(true);
    // const responselogo = await getClubLogo(`https://jamp.football${currentClub?.logo}`);
    const blob = await pdf(<RenderDocument data={reportData} staffData={staffList} esRichText={htmlStringES || ''} />).toBlob();
    saveAs(blob, "download.pdf");
    setIsDownloadingReport(false);
  };

  const fetchReportData = async () => {
    setIsFetchingReport(true);
    const reportId = selected ? selected : null;
    const response = await getEvaluationReport({ 
        clubId: currentClub?.id,
        reportId: reportId
    });
    const parsedData = JSON.parse(response.data);
    var sortedData = parsedData?.Criteria.map((d:any) => {return { ...d, UidNum: parseInt(genUID(d.Uid)) }});
    sortedData = sortedData
    .sort((a:any, b:any) => {
        const uid1 = a.UidNum; 
        const uid2 = b.UidNum;
        if (uid1 < uid2) {
          return -1;
        }
        if (uid1 > uid2) {
          return 1;
        }
        return 0;
      });
    dispatch(setReportData({...parsedData, Criteria: sortedData}));
    setIsFetchingReport(false);
  }

  useEffect(() => {
    !isFetchingReport && isFile && fetchReportData();
  }, [ isFile ]);

  return (
    <Box className={"reportsWrapperContainer"}>
      <Box className={"reportsHeader"}>
        <Box className={"mr20"}>
          <ButtonDefault
            variant={"outlined"}
            value={t("DOWNLOAD_REPORT")}
            manageOnClick={() => {
              downloadPDF();
            }}
            isLoading={isDownloadingReport}
            icon={<FontAwesomeIcon className={"fs13"} icon={faDownload} />}
          />
        </Box>
        <ButtonDefault
          variant={"outlined"}
          value={t("EDIT_REPORT")}
          manageOnClick={() => {}}
          icon={<FontAwesomeIcon className={"fs13"} icon={faPencil} />}
        />
      </Box>
      <Box className={"reportsMainContentWrapper"}>
        <Box className={"reportsFoldersWrapper"}>
          <ReportsFolderStructure />
        </Box>
        <Box className={"reportAreaWrapper"}>
          {!isFetchingReport ? <ReportEditor /> : <ReportSkeleton /> }
        </Box>
      </Box>
    </Box>
  );
};

export default ReportsWrapper;